import ServicesConfigEdit from './ServicesConfigEdit'
import { Subject } from '@mui/icons-material'

const servicesConfigIndex = {
  icon: Subject,
  edit: ServicesConfigEdit,
}

export default servicesConfigIndex
